module.exports = __webpack_public_path__ + "static/media/AvoidDave.c0234d5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/AvoidDave.jpg
// module id = 608
// module chunks = 0